import { ReactNode } from 'react';

interface MetricCardProps {
  label: string;
  value: string | number;
  change?: number;
  icon?: ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  className?: string;
}

export default function MetricCard({
  label,
  value,
  change,
  icon,
  trend,
  className = '',
}: MetricCardProps) {
  const trendColor = trend === 'up' ? 'text-success' : trend === 'down' ? 'text-danger' : 'text-gray-400';

  return (
    <div className={`metric-card ${className}`}>
      <div className="flex items-center justify-between mb-2">
        <span className="metric-label">{label}</span>
        {icon && <span className="text-lg">{icon}</span>}
      </div>
      <div className="flex items-end justify-between">
        <span className="metric-value">{value}</span>
        {change !== undefined && (
          <span className={`text-sm ${trendColor}`}>
            {change > 0 ? '↑' : change < 0 ? '↓' : '━'} {Math.abs(change)}
          </span>
        )}
      </div>
    </div>
  );
}
